export const useStyles = (theme) => ({
  root: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  inputRoot: {
    height: 70,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bold",
    backgroundColor: "#fff",
    paddingRight: 10,
  },
  notchedOutline: {},
  labelFocused: {
    color: "black !important",
  },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  inputMargin: {
    width: "49%",
    [theme.breakpoints.down(539)]: {
      width: "100%",
    },
  },
  tooltip: {
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
});
